import React from "react";

const ContactDetails = (props) => {
  const { language, appName } = props;
  const mailToLink = makeMailtoLink(appName);
  const text = getText(language, mailToLink);
  return <div>{text}</div>;
};

const makeMailtoLink = (appName) => {
  return `mailto:info@airecentre.org?subject=${appName}%20App%20-%20User%20Query`;
};

const getText = (language, mailToLink) => {
  switch (language) {
    case "en":
      return (
        <>
          <h3>Contact Details</h3>
          <p>
            Email: <a href={mailToLink}>info@airecentre.org</a>
            <br />
            Tel: +44 20 7831 4276
          </p>
        </>
      );
    case "bg":
      return (
        <>
          <h3>Данни за връзка</h3>
          <p>
            Имейл:: <a href={mailToLink}>info@airecentre.org</a>
            <br />
            Тел: +44 20 7831 4276
          </p>
        </>
      );
    case "it":
      return (
        <>
          <h3>Contatti</h3>
          <p>
            Email: <a href={mailToLink}>info@airecentre.org</a>
            <br />
            Tel: +44 20 7831 4276
          </p>
        </>
      );
    case "ru":
      return (
        <>
          <h3>Контактная информация</h3>
          <p>
            Email: <a href={mailToLink}>info@airecentre.org</a>
            <br />
            Тел: +44 20 7831 4276
          </p>
        </>
      );
    case "es":
      return (
        <>
          <h3>Datos de Contacto</h3>
          <p>
            Correo electrónico: <a href={mailToLink}>info@airecentre.org</a>
            <br />
            Tel: +44 20 7831 4276
          </p>
        </>
      );
    case "hi":
      return (
        <>
          <h3>संपर्क विवरण</h3>
          <p>
            Email: <a href={mailToLink}>info@airecentre.org</a>
            <br />
            Tel: +44 20 7831 4276
          </p>
        </>
      );

    default:
      break;
  }
};

export default ContactDetails;
